import * as React from "react";

import { Portal, UsePortalDropzone } from "../../Common";
import { FragmentDeliveryAddress } from "../fragment-delivery-address";
import { MyBagPresentationShippingDetailsOnCart } from "../model";
import { getLastKnownAddress } from "../delivery-details/address-sync-cache";
import { getLastKnownEmail } from "../delivery-details/email-sync-cache";

import {
  ReactCheckout2022RouteHash,
  useMyBagPresentationModel,
} from "../providers";

export const ThisOrderWillBeShippedTo: React.FunctionComponent = () => {
  const { presentationMyBagShippingDetailsOnCart } =
    useMyBagPresentationModel();

  const cachedAddress = getLastKnownAddress("shipping");
  const cachedEmail = getLastKnownEmail();
  const cachedShippingDetails: MyBagPresentationShippingDetailsOnCart | undefined =
    cachedEmail &&
    cachedAddress.firstName &&
    cachedAddress.lastName &&
    cachedAddress.mobile &&
    cachedAddress.addressLine1 &&
    cachedAddress.suburb &&
    cachedAddress.postcode &&
    cachedAddress.state &&
    cachedAddress.country
      ? {
          firstName: cachedAddress.firstName,
          lastName: cachedAddress.lastName,
          addressLine1: cachedAddress.addressLine1,
          addressLine2: cachedAddress.addressLine2,
          city: cachedAddress.suburb,
          stateLabel: cachedAddress.state,
          postcode: cachedAddress.postcode,
          country: cachedAddress.country.toUpperCase(),
          phone: cachedAddress.mobile,
          email: cachedEmail,
        }
      : undefined;

  const shippingDetails =
    presentationMyBagShippingDetailsOnCart || cachedShippingDetails;

  if (!shippingDetails) {
    return null;
  }
  return (
    <Portal
      selector={`
        .legacy-magento-checkout-container 
        > .legacy-magento-checkout-container-page-contents-container
        > .legacy-magento-checkout-container-direct-container
      `}
      dropzone={UsePortalDropzone.BeforeFirstChild}
      dontCreateRootElementWhenNone={true}
      portalStagingNodeClassName="legacy-magento-checkout-container--portal-this-order-will-be-shipped-to"
    >
      <section className="this-order-will-be-shipped-to">
        <h4>{`This order will be shipped to:`}</h4>

        <FragmentDeliveryAddress shippingDetails={shippingDetails} />

        <a href={`${ReactCheckout2022RouteHash.delivery_details}`}>
          <span>{`Edit Details`}</span>
        </a>
      </section>
    </Portal>
  );
};
